export const PAGE_SIZE_OPTIONS = [5, 10, 25, 50, 100];
  export const FREQUENCY_OPTIONS = [
    { value: "Monthly", label: "Monthly" },
    { value: "Weekly", label: "Weekly" },
    { value: "Yearly", label: "Yearly" },
    { value: "OneTime", label: "One-time" },
  ];

  export const INCOME_SOURCES = [
    { value: 'Salary', label: 'Salary' },
    { value: 'Business', label: 'Business' },
    { value: 'Investment', label: 'Investment' },
    { value: 'Other', label: 'Other' }
  ];
  export const INCOME_FREQUENCIES = [
    { value: 'Monthly', label: 'Monthly' },
    { value: 'Weekly', label: 'Weekly' },
    { value: 'Yearly', label: 'Yearly' },
    { value: 'Daily', label: 'Daily' },
    { value: 'OneTime', label: 'One Time'},
  ];

  export const SUB_FREQUENCY_OPTIONS = [
    { value: "Monthly", label: "Monthly" },
    { value: "Quarterly", label: "Quarterly" },
    { value: "Yearly", label: "Yearly" },
  ];

  export const savingTableColumns = [
    "Title", "Target Amount", "Current Amount", "Target Date", "Status",
    "Account", "Remaining", "Progress", "Actions"
  ];

  export const incomeTableColumns = [
    "Income", "Source", "Frequency", "Amount", "Bonus", "Currency", "Total yearly", "Total in Base Currency", "Account", "Deposit Date", "Actions"
  ];

  export const subscriptionTableColumns = [
    "Item", "Category", "Frequency", "Amount", "Subscription Date", "Renewal Date", "Account", "Actions"
  ];

  export const DEBT_TYPE_OPTIONS = [
    { value: "personal_loan", label: "Personal Loan" },
    { value: "credit_card", label: "Credit Card" },
    { value: "student_loan", label: "Student Loan" },
    { value: "auto_loan", label: "Auto Loan" },
    { value: "medical_debt", label: "Medical Debt" },
    { value: "other", label: "Other" },
  ];

  export const DEBT_STATUS_OPTIONS = [
    { value: "active", label: "Active" },
    { value: "paid_off", label: "Paid Off" },
    { value: "settled", label: "Settled" },
  ];

  export const debtTableColumns = [
    "Title",
    "Initial Amount",
    "Amount Repaid",
    "Balance",
    "Interest Rate",
    "Monthly Payment",
    "Start Date",
    "Due Date",
    "Estimated Final Payment Date",
    "Account",
    "Action",
  ];

  export const mortgageTableColumns = [
    "Property Name",
    "Initial Amount",
    "Amount Repaid",
    "Interest Rate (%)", 
    "Monthly Payment",
    "Start Date",
    "Monthly Payment Due Date",
    "Account",
    "Actions",
  ];

  export const accountTableHeader =[
    "Account", "Type", "Currency", "Balance", "Balance in Base Currency", "Actions"
  ]

  export const investmentTypes = ["Stock", "Bond", "Fund", "ETF", "Crypto", "other"];
  export const tradeTypes = ["buy", "sell"];

  export const tradeOptions = [
    { value: "buy", label: "Buy" },
    { value: "sell", label: "Sell" }
  ];

  export const  investmentTableColumns = [
    "Asset",
    "Ticker",
    "Type",
    "Trade",
    "Units",
    "Cost",
    "Order Price",
    "Account",
    "Actions",
  ];

  export const accountColumns = [
    { key: "month", label: "Month" },
    { key: "totalBalance", label: "Balance", isAmount: true },
    { key: "gainOrReduce", label: "Gain/Reduce" },
  ];
  
  export const savingColumns = [
    { key: "month", label: "Month" },
    { key: "totalSavings", label: "Total Savings", isAmount: true },
    { key: "totalAdded", label: "Added Savings", isAmount: true },
  ];
  
  export const budgetColumns = [
    { key: "month", label: "Month" },
    { key: "plannedSpend", label: "Planned Spend", isAmount: true },
    { key: "actualSpend", label: "Actual Spend", isAmount: true },
    { key: "variance", label: "Variance", isVariance: true },
  ];

  export const budgetTableColumns = [
      'Item', 'Category', 'Frequency', '%Allocation', 'Planned Cost', 'Actual Cost', 'Tag', 'Account', 'Actions'
  ];
  
  export const debtColumns = [
    { key: "month", label: "Month" },
    { key: "debtBalance", label: "Balance", isAmount: true },
    { key: "debtPaid", label: "Debt Paid", isAmount: true },
  ];
  
  export const mortgageColumns = [
    { key: "month", label: "Month" },
    { key: "mortgageBalance", label: "Balance", isAmount: true },
    { key: "mortgagePaid", label: "Mortgage Paid", isAmount: true },
    { key: "propertyValue", label: "Property Value", isAmount: true },
  ];


  export const MORTGAGE_STATUS_OPTIONS = [
    { value: 'active', label: 'Active' },
    { value: 'paid_off', label: 'Paid Off' },
    { value: 'settled', label: 'Settled' },
    { value: 'defaulted', label: 'Defaulted' },
  ];

  
  export const investmentColumns = [
    { key: "month", label: "Month" },
    { key: "totalPortfolioValue", label: "Portfolio Value", isAmount: true },
    { key: "addedInvestments", label: "Added Investment", isAmount: true },
    { key: "profitLossPercentage", label: "%P/L" },
  ];

  export const CATEGORIES = [
    'Entertainment', 'Music', 'Streaming', 'Gaming', 'Software', 'News',
    'Education', 'Fitness', 'Health', 'Shopping', 'Cloud Storage', 'Security',
    'Communication', 'Business Tools', 'Design', 'Food Delivery', 'Transportation',
    'Finance', 'Insurance', 'Utilities',
    'Rent', 'Housing', 'Groceries', 'Food', 'Dining', 'Gifts', 'Miscellaneous',
    'Vacation', 'Travel', 'Fun', 'Hygiene', 'Personal Care', 'Children', 'Pets',
    'Medical', 'Charity', 'Taxes', 'Savings', 'Investments', 'Clothing', 'Internet',
    'Mobile', 'Electricity', 'Water', 'Gas', 'Maintenance', 'Subscriptions'
  ];

  export const accountTypes = [
    { key: 'current', label: 'Current', value: 'Current' },
    { key: 'checking', label: 'Checking', value: 'Checking' },
    { key: 'savings', label: 'Savings', value: 'Savings' },
    { key: 'investment', label: 'Investment', value: 'Investment' },
    { key: 'taxAdvantaged', label: 'Tax Advantaged', value: 'TaxAdvantaged' }
  ];

  export const investmentTableFields = [
        "assetName",
        "ticker",
        "type",
        "trade",
        "tradeDate",
        "orderPrice",
        "currency",
        "units",
        "cost",
        "paymentAccountId",
        'lastClosePriceDate'
  ];

  export const LEVEL_COLORS = {
  beginner: 'success',
  intermediate: 'warning',
  advanced: 'error'
};


//Investment Table Column

  // Table columns
  export const portfolioColumns = [
    'Asset', 'Ticker', 'Type', 'Currency', 'Total Units', 'Cost', '% Portfolio', 'Order Price', 'Last Close Price', 'Last Updated', 'Value', 'P/L', 'Actions'
  ];
  export const transactionColumns = ['Date', 'Trade', 'Currency', 'Units', 'Price', 'Cost', 'Account', 'Notes', 'Actions'];

